import React from 'react';
import { currencyFormatter } from 'utils/formatter';
import CogsInfoPopover from './CogsInfoPopover';
import RenderByScreenSize from '../../RenderByScreenSize';
import MarginLabel from './MarginLabel';
import PlainTableRow from './PlainTableRow';

function GrossProfitReportTable(props) {
  const { grossProfitReport } = props;
  const {
    cogsAdjustment,
    cogs,
    netSales,
    grossProfit,
    discount,
    grossSales,
    refund,
  } = grossProfitReport;

  const showCogsAdjustment = cogsAdjustment !== 0;
  const isLargeScreen = window.matchMedia('(min-width: 992px)').matches;
  const showMargin = isLargeScreen && (cogs !== 0 && netSales > 0);
  const cogsPercent = Math.round((cogs / netSales) * 100);
  const grossProfPercent = Math.round((grossProfit / netSales) * 100);
  const cogsAdjustmentPercent = Math.round((cogsAdjustment / netSales) * 100);

  return (
    <table className="table table-responsive mk-table-summary no-margin">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          {showMargin && <th />}
        </tr>
      </thead>

      <tbody>
        <PlainTableRow
          label="Gross Sales"
          amount={currencyFormatter(grossSales)}
        />

        <PlainTableRow
          label="Discounts"
          amount={currencyFormatter(-discount)}
        />

        <PlainTableRow label="Refunds" amount={currencyFormatter(-refund)} />

        <tr className="divider">
          <td>
            <strong>Net Sales</strong>
          </td>
          <td className="text-right">
            <strong>{currencyFormatter(netSales)}</strong>
          </td>
          {showMargin && (
            <td>
              <MarginLabel danger={netSales < 0} value={100} />
            </td>
          )}
        </tr>

        <PlainTableRow
          label={
            <RenderByScreenSize
              renderLargeScreen={() => <span>Cost of Goods Sold (COGS)</span>}
              renderSmallScreen={() => <span>COGS</span>}
            />
          }
          amount={currencyFormatter(-cogs)}
          showMargin={showMargin}
          margin={<MarginLabel danger={cogs >= 0} value={cogsPercent} />}
        />

        {showCogsAdjustment && (
          <PlainTableRow
            label={
              <RenderByScreenSize
                renderLargeScreen={() => (
                  <span>
                    Cost of Goods Sold (COGS) Adjustment <CogsInfoPopover />
                  </span>
                )}
                renderSmallScreen={() => (
                  <span>
                    COGS Adjustment <CogsInfoPopover />
                  </span>
                )}
              />
            }
            amount={currencyFormatter(-cogsAdjustment)}
            showMargin={showMargin}
            margin={
              <MarginLabel
                danger={cogsAdjustment >= 0}
                value={Math.abs(cogsAdjustmentPercent)}
              />
            }
          />
        )}
      </tbody>
      <tfoot>
        <tr className="text-total">
          <td>
            <strong>Gross Profit</strong>
          </td>
          <td className="text-right">
            <strong>{currencyFormatter(grossProfit)}</strong>
          </td>
          {showMargin && (
            <td>
              <MarginLabel danger={grossProfit < 0} value={grossProfPercent} />
            </td>
          )}
        </tr>
      </tfoot>
    </table>
  );
}

export default GrossProfitReportTable;
